import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "town-list" },
    _vm._l(_vm.towns, function (town) {
      return _c(
        VBtn,
        {
          key: town.name,
          staticClass: "d-flex justify-start text--text pa-3 cursor-pointer",
          attrs: {
            "data-qa": "dialog-town-item",
            color: "text",
            text: "",
            block: "",
          },
          on: {
            click: function ($event) {
              return _setup.redirectTown(town)
            },
          },
        },
        [
          _c("span", { staticClass: "text--text", class: _vm.textStyle }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.transDynamic(
                    town,
                    `name,${_setup.language},${_setup.needTranslate}`
                  )
                ) +
                "\n    "
            ),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }